import { render, staticRenderFns } from "./TheoryDetail.vue?vue&type=template&id=457ab891&scoped=true&"
import script from "./TheoryDetail.vue?vue&type=script&lang=js&"
export * from "./TheoryDetail.vue?vue&type=script&lang=js&"
import style0 from "./TheoryDetail.vue?vue&type=style&index=0&id=457ab891&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457ab891",
  null
  
)

export default component.exports